import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
	selector: 'pcm-data-form-field-text',
	templateUrl: './data-form-field-text.component.html'
})
export class DataFormFieldTextComponent {
	@Input() propName: string;
	@Input() name: string;
	@Input() formGroup: UntypedFormGroup;
	@Input() helpMessage: string;
	@Input() invalid = false;
	@Input() invalidText: string;
	@Input() required = false;
	@Input() type = 'text';
	@Input() forceLowerCase = false;

	handleInputChange(event): void {
		if (this.forceLowerCase) {
			this.formGroup.get(this.propName).setValue(event.target.value.toLowerCase());
		}
	}
}
